"use strict";
function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;
//# sourceMappingURL=_baseIsNaN.js.map